import { BaseModel } from "~/model"
import { useAuthStore, useClientStore } from "~/stores"

export class AdresseModel extends BaseModel {
    static primaryKey = "IDADRESSE"

    // Couleurs Lola de l'etat du projet. Un marqueur regroupe plusieurs projets :
    // l'ordre de ce tableau est la priorite d'affichage.
    static ETATS_CARTE = [
        {
            key: "orange",
            field: "NB_ORANGE",
            color: "#D66515",
            text: "En cours",
        },
        { key: "vert", field: "NB_VERT", color: "#2E7D32", text: "Non signé" },
        {
            key: "violet",
            field: "NB_VIOLET",
            color: "#821FDF",
            text: "Réalisé",
        },
        { key: "rouge", field: "NB_ANNULE", color: "#C62828", text: "Annulé" },
    ]

    get client() {
        const clientStore = useClientStore()
        // Adresse de chantier (carte) : client par identifiant ; repli sur le domicile.
        return (
            clientStore.itemById[this.CLIENT?.IDCLIENT] ??
            clientStore.clientByIdAdresse[this.IDADRESSE]
        )
    }

    // Etat dominant du marqueur ; undefined pour une adresse sans compteurs (cache ancien).
    get etatCarte() {
        return AdresseModel.ETATS_CARTE.find((etat) => this[etat.field] > 0)
    }

    // "mine" = mon client, "agence" = client de mon agence, "autre" sinon.
    get appartenance() {
        const user = useAuthStore().getUser
        const client = this.client
        if (client?.IDPERSONNEL === user?.IDPERSONNEL)
            return { key: "mine", text: "Mon client" }
        if (client?.IDAGENCE === user?.IDAGENCE)
            return { key: "agence", text: "Client de mon agence" }
        return { key: "autre", text: "Client d'une autre agence" }
    }

    get markerColor() {
        const etat = this.etatCarte
        return {
            color: etat?.color ?? "#607D8B",
            text: etat?.text ?? "Adresse",
        }
    }

    get center() {
        return [this.LATITUDE, this.LONGITUDE]
    }
}
